/**
 * 14. Marketplace — browse packs, connectors, extensions; install/update;
 * compatibility status. Packs are Country / Industry / Connector / Report /
 * Workflow definitions served from GET /v1/marketplace/packs.
 */
import {
  Card,
  PageHeader,
  Badge,
  Button,
  DataTable,
  Skeleton,
  StatusBadge,
} from "@/components/ui";
import { useApiList } from "@/lib/api/hooks";

interface Pack {
  id: string;
  code: string;
  name: string;
  packType: "Country" | "Industry" | "Connector" | "Report" | "Workflow";
  version: number;
  status: "Draft" | "Validated" | "Certified" | "Published" | "Deprecated";
  isInstalled: boolean;
}

export function MarketplacePage() {
  const { data, isLoading } = useApiList<Pack>(
    ["marketplace", "packs"],
    "/marketplace/packs",
  );

  return (
    <div>
      <PageHeader
        title="Marketplace"
        subtitle="Install country packs, industry packs, connectors, reports, and workflow packs."
      />
      {isLoading || !data ? (
        <Skeleton rows={8} />
      ) : (
        <Card title={`Available packs (${data.total})`}>
          <DataTable<Pack>
            rows={data.items}
            columns={[
              { key: "name", label: "Pack" },
              {
                key: "code",
                label: "Code",
                render: (r) => <span className="atlas-mono">{r.code}</span>,
              },
              {
                key: "packType",
                label: "Type",
                render: (r) => <Badge tone="primary">{r.packType}</Badge>,
              },
              { key: "version", label: "Version", numeric: true },
              {
                key: "status",
                label: "Status",
                render: (r) => <StatusBadge status={r.status} />,
              },
              {
                key: "isInstalled",
                label: "Action",
                render: (r) =>
                  r.isInstalled ? (
                    <Button size="sm">Manage</Button>
                  ) : (
                    <Button size="sm" variant="primary">
                      Install
                    </Button>
                  ),
              },
            ]}
          />
        </Card>
      )}
    </div>
  );
}
